
import React from "react";
import {
	Box,
	Container,
	Typography,
	Divider,
	Paper,
	Stack,
} from "@mui/material";
import TopBar from "./globalComponents/topbar";
import Footer from "./globalComponents/footer";

const PrivacyPolicy = () => {
	return (
		<Box sx={{ backgroundColor: "#F6F7F9", minHeight: "100vh" }}>
			<TopBar />

			{/* Main Content */}
			<Container maxWidth="lg" sx={{ py: 5 }}>
				<Typography
					variant="h4"
					fontWeight="bold"
					sx={{ mb: 4, textAlign: "center", color: "#010101" }}
				>
					Privacy Policy
				</Typography>

				<Paper
					elevation={2}
					sx={{
						p: 4,
						borderRadius: 3,
						backgroundColor: "#fff",
					}}
				>
					{/* Header */}
					<Typography
						variant="h5"
						fontWeight="bold"
						sx={{ mb: 2, color: "#6C6C6C" }}
					>
						Privacy Policy Document
					</Typography>
					<Divider sx={{ mb: 4 }} />

					{/* Section 1 */}
					<Stack spacing={1} sx={{ mb: 5 }}>
						<Typography variant="h6" fontWeight="bold" color="text.primary">
							1. Introduction (Purpose of the Terms)
						</Typography>
						<Typography variant="body1" color="text.secondary">
							Welcome to The Mentorship and Networking Hub. Your privacy is
							important to us. This Privacy Policy explains how we collect, use,
							share, and protect your personal information when you use our app.
							Our goal is to provide a secure and meaningful mentorship
							experience while respecting your data and privacy rights.
						</Typography>
					</Stack>

					<Divider sx={{ mb: 5 }} />

					{/* Section 2 */}
					<Stack spacing={1} sx={{ mb: 5 }}>
						<Typography variant="h6" fontWeight="bold" color="text.primary">
							2. What Data We Collect (User-Provided & System-Collected Data)
						</Typography>
						<Typography variant="body1" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
							{`We collect two types of data:\n
User-Provided Data: Information you provide when creating an account, such as your name, email, profile details, mentorship preferences, and any messages or content shared within the app.\n
System-Collected Data: Technical information such as device type, IP address, usage logs, and app performance analytics to improve our services.\n
We only collect necessary data to enhance your mentorship experience and ensure platform security.`}
						</Typography>
					</Stack>

					<Divider sx={{ mb: 5 }} />

					{/* Section 3 */}
					<Stack spacing={1} sx={{ mb: 5 }}>
						<Typography variant="h6" fontWeight="bold" color="text.primary">
							3. How We Use Your Data
						</Typography>
						<Typography variant="body1" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
							{`We use your information to:\n
• Facilitate mentorship matching based on your profile, skills, and preferences.\n
• Personalize your experience with recommended mentors/students and relevant content.\n
• Improve app performance and user experience through analytics and feedback.\n
• Provide customer support and respond to inquiries.\n
• Ensure security, prevent fraud, and comply with legal obligations.\n
Your data is never used for any purpose outside these stated objectives.`}
						</Typography>
					</Stack>

					<Divider sx={{ mb: 5 }} />

					{/* Section 4 */}
					<Stack spacing={1}>
						<Typography variant="h6" fontWeight="bold" color="text.primary">
							4. Data Sharing & Third-Party Access (Who Has Access & Why?)
						</Typography>
						<Typography variant="body1" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
							{`We respect your privacy and limit data sharing. However, we may share certain information with:\n
• Mentors & Students: To enable effective mentorship connections.\n
• Service Providers: Trusted third parties that help with hosting, analytics, and security (they are bound by strict confidentiality agreements).\n
• Legal & Compliance Authorities: If required by law to prevent fraud or enforce policies.\n
We never sell or trade your data with third parties for marketing purposes.`}
						</Typography>
					</Stack>
				</Paper>
			</Container>

			<Footer />
		</Box>
	);
};

export default PrivacyPolicy;
